/* Repositions one server-rendered REVIVE ribbon roughly a third of the way into each blog article. */
(() => {
  function positionReviveRibbons() {
    document.querySelectorAll('.article-template__content').forEach(article => {
      const ribbon = article.querySelector('.vassia-revive-ribbon');
      if (!ribbon || ribbon.dataset.revivePositioned === 'true') return;

      const root = article.querySelector('.vassia-reader') || article;
      const candidates = Array.from(root.querySelectorAll('p')).filter(p => {
        if (p.closest('.vassia-reader__contents, .vassia-reader__cta, .vassia-revive-ribbon, aside, nav, blockquote, details, figure, figcaption, header, footer, li')) return false;
        return (p.textContent || '').trim().length >= 85;
      });
      if (candidates.length > 0) {
        const at = Math.min(candidates.length - 1, Math.max(0, Math.floor(candidates.length * 0.36)));
        candidates[at].insertAdjacentElement('afterend', ribbon);
      } else {
        const headings = Array.from(root.querySelectorAll('h2')).filter(h =>
          !h.closest('.vassia-reader__contents, aside, nav, .vassia-reader__cta')
        );
        if (headings.length > 1) headings[1].insertAdjacentElement('afterend', ribbon);
        else root.insertAdjacentElement('afterbegin', ribbon);
      }
      ribbon.dataset.revivePositioned = 'true';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionReviveRibbons, { once: true });
  } else {
    positionReviveRibbons();
  }
  document.addEventListener('shopify:section:load', positionReviveRibbons);
})();
